import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LinearProgress, Skeleton, Stack, Tooltip, Typography } from '@mui/material';
import { StatusIcons } from '../../../../../../../../Iconography';
const percentage = (value, total) => (value / Math.max(total, 1)) * 100;
export const evaluateStatus = (status) => {
    const total = status.length;
    const disabled = status.every((s) => s.requestedConfigDisabled);
    const reported = status.every((s) => s.reportedConfigMatches);
    const reportedTotal = status.filter((s) => s.reportedConfigMatches).length;
    let output = {
        iconStatus: 'disabled',
        progressStatus: 'inherit',
        progress: 0,
        summary: '',
        message: '',
    };
    if (disabled)
        output = {
            iconStatus: reported ? 'inherit' : 'info',
            progressStatus: reported ? 'inherit' : 'info',
            progress: percentage(total - reportedTotal, total),
            summary: `${reportedTotal} / ${total} disabled`,
            message: `${reportedTotal} / ${total} have this schedule disabled}`,
        };
    else
        output = {
            iconStatus: reported ? 'success' : 'info',
            progressStatus: reported ? 'success' : 'info',
            progress: percentage(reportedTotal, total),
            summary: `${reportedTotal} / ${total} applied`,
            message: `${reportedTotal} / ${total} applied`,
        };
    return output;
};
export const ScheduleStatus = ({ loaded, status }) => {
    const { iconStatus, progressStatus, progress, summary, message } = evaluateStatus(status);
    return (_jsxs(Stack, { direction: 'row', gap: 1, children: [loaded ? (_jsx(StatusIcons.InTransmission, { color: iconStatus, sx: { paddingInline: 1 } })) : (_jsx(Skeleton, { variant: "rounded", width: 24, height: 24, sx: { marginInline: 1 } })), _jsxs(Stack, { flexGrow: 1, gap: 0.5, children: [_jsx(Stack, { direction: 'row', children: loaded ? (_jsx(Tooltip, { title: message, placement: 'top', arrow: true, children: _jsx(Typography, { variant: "body2", children: summary }) })) : (_jsx(Skeleton, { variant: "text", width: 80, height: 20 })) }), loaded ? (_jsx(LinearProgress, { variant: 'determinate', value: progress, color: progressStatus })) : (_jsx(Skeleton, { variant: "rectangular", animation: "wave", width: "100%", height: 4 }))] })] }));
};
